import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  LinearProgress,
  CircularProgress,
  Typography,
  Box,
  makeStyles
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(3),
    minWidth: 400,
  },
  progressContainer: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  circularProgress: {
    marginBottom: theme.spacing(2),
  },
  message: {
    textAlign: 'center',
    marginBottom: theme.spacing(2),
  },
  percentage: {
    fontWeight: 'bold',
    fontSize: '1.2rem',
    color: theme.palette.primary.main,
  },
}));

const ImportProgressModal = ({ 
  open, 
  processed, 
  total, 
  message, 
  action,
  onCancel 
}) => {
  const classes = useStyles();
  
  const percentage = total > 0 ? Math.round((processed / total) * 100) : 0;
  
  const getTitle = () => {
    switch (action) {
      case 'progress':
        return 'Importando Contatos';
      case 'completed':
        return 'Importação Concluída';
      case 'cancelled':
        return 'Importação Cancelada';
      default:
        return 'Processando...';
    }
  };

  const showCancelButton = action === 'progress';

  return (
    <Dialog 
      open={open} 
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          // Permitir fechar apenas se não for clique no backdrop
        }
      }}
      disableEscapeKeyDown
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>{getTitle()}</DialogTitle>
      <DialogContent>
        <div className={classes.content}>
          <div className={classes.circularProgress}>
            <CircularProgress 
              variant="determinate" 
              value={percentage} 
              size={80}
              thickness={4}
            />
          </div>
          
          <div className={classes.progressContainer}>
            <LinearProgress 
              variant="determinate" 
              value={percentage} 
            />
          </div>
          
          <Typography variant="h6" className={classes.percentage}>
            {processed} de {total} contatos ({percentage}%)
          </Typography>
        </div>
      </DialogContent>
      
      {showCancelButton && (
        <DialogActions>
          <Button 
            onClick={onCancel} 
            color="secondary"
            variant="outlined"
          >
            Cancelar Importação
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default ImportProgressModal;